import {
  createSpaceObjectFromBack,
  SpaceObjectFormatter,
  SstFormatter,
} from '@entities/SpaceObject/responseFormatters';
import { createSstFromBack } from '@entities/Sst/responseFormatter';

/**
 * The two formatters that need each other: a block embeds the object it is
 * about, and an object embeds its latest blocks. Each module exports a factory
 * taking the other formatter, and this file is the only place both are known,
 * so the entity modules stay free of each other at runtime. The block formatter
 * reaches the object formatter through a closure: it is built first, and the
 * object formatter it needs does not exist yet.
 */
export const sstFromBack: SstFormatter = createSstFromBack(spaceObject => spaceObjectFromBack(spaceObject));
export const spaceObjectFromBack: SpaceObjectFormatter = createSpaceObjectFromBack(sstFromBack);
